module.exports = __webpack_public_path__ + "static/img/4a.ab4369f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/why/4a.png
// module id = xIoc
// module chunks = 1